<template>
    <div class="FilhanteringPerson colspan c8">
        <input-wrapper
            v-if="isGenerellFil"
            :component="PopoutSuggestWidget"
            label="Sök patient"
            apisearch="/core/patienter/"
            @input="setPatient"
            information="Sök personID eller namn"
            :map="
                (pat) => {
                    return {
                        id: pat.id,
                        code: pat.id,
                        displayName: `${pat.personId_formatted} ${pat.fornamn} ${pat.efternamn}`,
                    };
                }
            "
        />

        <input-wrapper :component="DisplayTextWidget" label="PersonID" v-model="personId_formatted" />

        <input-wrapper :component="DisplayTextWidget" label="Typ av personID" v-model="personIdTypeName" />

        <input-wrapper :component="DisplayTextWidget" label="Patientnamn" v-model="patientNamn" />
    </div>
</template>

<script>
    import { getConfig, getErrorMessage, klinikenApi } from "@/api";
    import DisplayTextWidget from "@/components/widgets/inputs/DisplayTextWidget.vue";
    import InputWrapper from "@/components/widgets/inputs/InputWrapper.vue";
    import PopoutSuggestWidget from "@/components/widgets/inputs/PopoutSuggestWidget.vue";
    import { inject } from "vue";

    export default {
        name: "FilhanteringPersonInlastFil",

        components: {
            InputWrapper,
        },
        props: { index: Number },
        data() {
            return {
                personIdType2Name: {
                    "1.2.752.129.2.1.3.1": "Personnummer",
                    "1.2.752.129.2.1.3.3": "Samordningsnummer",
                    "1.2.752.97.3.1.3": "SLL reservnummer",
                    kliniken2: "Kliniken 2",
                    skreg: "Skaderegistret",
                },

                formErrors: [],
                DisplayTextWidget,
                PopoutSuggestWidget,
                patient: null,
            };
        },
        setup() {
            const isGenerellFil = inject("isGenerellFil");

            return { isGenerellFil };
        },
        computed: {
            personIdTypeName() {
                if (this.patient) {
                    //  Lista ut vårt personIdTypeName
                    const personIdType = this.patient.personIdType;
                    let result = this.personIdType2Name[personIdType];

                    // Om vi inte får någon träff returnerar vi koden som den är
                    if (result === undefined) {
                        result = personIdType;
                    }
                    return result;
                } else {
                    return "–";
                }
            },
            patientNamn() {
                if (this.patient) {
                    return `${this.patient.namn}`;
                } else {
                    return "–";
                }
            },
            personId() {
                if (this.patient) {
                    return this.patient.personId;
                } else {
                    return "–";
                }
            },
            personId_formatted() {
                if (this.patient) {
                    return this.patient.personId_formatted;
                } else {
                    return "–";
                }
            },
        },
        methods: {
            async setPatient(data) {
                if (data) {
                    try {
                        const response = await klinikenApi.get(`/core/patienter/${data}/`, getConfig());
                        this.patient = response.data;
                        this.$emit("changePatient", this.patient);
                    } catch (e) {
                        openDialog("Kunde inte hämta patient: " + getErrorMessage(e), "warning");
                    }
                } else {
                    this.patient = null;
                    this.$emit("changePatient", null);
                }
            },
        },
        created() {
            if (this.$store.state.filhantering.redigering.metaData.patientUUID) {
                this.patient = {
                    id: this.$store.state.filhantering.redigering.metaData.patientUUID,
                    personId: this.$store.state.filhantering.redigering.metaData.personId,
                    personId_formatted: this.$store.state.filhantering.redigering.metaData.personId_formatted,
                    personIdType: this.$store.state.filhantering.redigering.metaData.personIdType,
                    fornamn: this.$store.state.filhantering.redigering.metaData.fornamn,
                    efternamn: this.$store.state.filhantering.redigering.metaData.efternamn,
                    namn: this.$store.state.filhantering.redigering.metaData.namn,
                };
            }
        },
    };
</script>

<style lang="scss" scoped>
    div.FilhanteringPerson {
        display: flex;
        flex-direction: row;
    }
</style>
